import { navLinks } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-secondary-100">
      <div className="px-4 md:px-8 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                韩国伦理电影在线观看
              </span>
            </div>
            <p className="mt-4 max-w-xl text-sm text-secondary-200 leading-relaxed">
              本站为影迷提供韩国伦理电影的类型梳理、代表作品与观影参考，覆盖高清中字与完整版的合法观看思路。
              我们鼓励通过正规渠道观看影视作品，尊重版权与创作者。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">页面导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-y-2.5 gap-x-4">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-secondary-200 hover:text-accent-300 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-secondary-300">
            © {new Date().getFullYear()} 韩国伦理电影在线观看 · 内容仅供观影参考
          </p>
          <p className="text-xs text-secondary-300">
            部分作品含成人内容，请确认符合观看年龄后再选择观看
          </p>
        </div>
      </div>
    </footer>
  );
}